import {Papa} from 'ngx-papaparse';

export class NICEDataDownload {
    uri: string;
    errorMessage: string;
    data: any;

    constructor(dd?: any) {
        const papaConfig = {
            header: true,
            skipEmptyLines: true,
        };
        if (dd) {
            const papa = new Papa();
            const fileDataCSV = atob(dd.file);
            this.data = papa.parse(fileDataCSV, papaConfig);
            this.uri = dd.URI;
            this.errorMessage = dd.errorMessage;
        }
    }
}

